import React from 'react';
import type { ReferenceField } from '@uncinc/react-drupal-core/types';

import ButtonWrapper from '../ButtonWrapper';
import { TaxonomyTheme } from '../../types/uncinc_profile/taxonomy';

import ThemeTagItem from './ThemeTagItem';

import './style.scss';

interface ThemeTagsProps {
  title?: string;
  themes: (TaxonomyTheme | ReferenceField<TaxonomyTheme>)[];
  linkUrl?: string;
  linkTitle?: string;
}

const ThemeTags: React.FC<ThemeTagsProps> = ({
  title,
  themes,
  linkUrl,
  linkTitle,
}) => (
  <div className="ThemeTags">
    {title && <h2 className="ThemeTags__title">{title}</h2>}
    <ul className="ThemeTags__tags">
      {themes.map((theme) => (
        <li>
          <ThemeTagItem
            theme={theme}
          />
        </li>
      ))}
    </ul>
    {linkUrl && (
      <ButtonWrapper
        className="ThemeTags__link"
        href={linkUrl}
      >
        {linkTitle}
      </ButtonWrapper>
    )}
  </div>
);

export default ThemeTags;
